// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop: Noop = () => {};
export default noop;
